/* Lagom theme core. Loaded once (defer) on every page. Small on purpose: helpers, the motion switch, the dispatch
   function, the header, the phone menu, the cart count + toast, reveal-on-scroll, section-editor events.
   Section scripts (section-*.js) use window.Lagom.{q, qa, motionOff, dispatchInfo, cart, track, onView}. */
(function () {
  'use strict';
  var L = window.Lagom = window.Lagom || {};
  var C = L.config || {};

  /* ---------- helpers ---------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  L.q = q; L.qa = qa;

  /* ---------- motion switch: reduced motion, ?capture=1, or the theme setting ---------- */
  var CAPTURE = /[?&]capture=1(?:&|$)/.test(location.search);
  L.off = {};   /* the ?off= / ?perf= test switches were removed after the diagnosis */
  if (CAPTURE) { document.documentElement.classList.add('is-capture'); }
  var REDUCE = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var OFF = C.motion && C.motion.enabled === false;
  L.MOTION = {
    get matches() { return CAPTURE || OFF || !!REDUCE.matches; },
    addEventListener: function (type, fn) { if (REDUCE.addEventListener) { REDUCE.addEventListener(type, fn); } else if (REDUCE.addListener) { REDUCE.addListener(fn); } }
  };
  L.motionOff = function () { return L.MOTION.matches; };
  L.CAPTURE = CAPTURE;
  /* One scroll lock for the menu, the cart drawer, the FAQ sheet and the manifesto. No reflow: the page is not moved or
     restyled (fixing the body re-lays out the whole page and that is what made opening/closing lag on phones). Touch
     screens: touchmove outside the open panel is cancelled (the panel's own scrollable part still scrolls). Pointer
     devices: html overflow hidden (CSS, hover: hover). Keys nest (menu -> link -> close). */
  L.lock = (function () {
    var keys = {};
    var PANELS = '.cart-panel, .manifesto, .header__nav, .lsel__menu';
    document.addEventListener('touchmove', function (e) {
      if (!Object.keys(keys).length) { return; }
      if (e.touches.length > 1) { return; }   /* two fingers = pinch zoom: always the browser's (zoomed in, the panel fills the screen) */
      var panel = e.target.closest && e.target.closest(PANELS);
      if (panel) {   /* inside an open panel: a scrollable part of it may scroll */
        var el = e.target;
        while (el && el !== panel.parentNode) { var cs = getComputedStyle(el); if (/auto|scroll/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1) { return; } el = el.parentNode; }
      }
      if (e.cancelable) { e.preventDefault(); }
    }, { passive: false });
    return {
      lock: function (k) { keys[k] = true; document.documentElement.classList.add('is-locked'); },
      unlock: function (k) { delete keys[k]; if (!Object.keys(keys).length) { document.documentElement.classList.remove('is-locked'); } },
      has: function (k) { return !!keys[k]; }, y: function () { return window.pageYOffset; }
    };
  })();
  /* In-app browsers (TikTok, Instagram, Facebook, Snapchat, Messenger, Line): no JIT and a slow compositor. Lite mode:
     the tabs open without a height animation. Everything else (clouds, grain, fish) stays as it is. */
  L.inApp = (function (ua) {
    if (/musical_ly|Bytedance|TikTok|Trill|Aweme/i.test(ua)) { return 'TikTok'; }
    if (/Instagram/i.test(ua)) { return 'Instagram'; }
    if (/FBAN|FBAV|FB_IAB|FBIOS|Messenger/i.test(ua)) { return 'Facebook'; }
    if (/Snapchat/i.test(ua)) { return 'Snapchat'; }
    if (/Line\//.test(ua)) { return 'Line'; }
    if (/Twitter|X11; .*Mobile.*Twitter/i.test(ua)) { return 'X'; }
    if (/; wv\)|Version\/[\d.]+ Chrome\/[\d.]+ Mobile/.test(ua) && /Android/.test(ua)) { return 'Android WebView'; }
    if (/iPhone|iPad|iPod/.test(ua) && !/Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua)) { return 'iOS WebView'; }   /* in-app browsers on iOS drop "Safari/" from the UA */
    return '';
  })(navigator.userAgent || '');
  L.lite = !!L.inApp;
  /* The scroll position, read once per scroll event (before any frame work writes styles). Reading pageYOffset inside a
     requestAnimationFrame after another module wrote a style forces a layout; everything scroll-linked uses L.scrollY. */
  L.scrollY = 0;
  window.addEventListener('scroll', function () { L.scrollY = window.pageYOffset; }, { passive: true });
  window.requestAnimationFrame(function () { L.scrollY = window.pageYOffset; });   /* first read in a frame, after the first paint, never during script execution */
  /* Work that is not needed for the first screen runs in idle time after the first paint (the init was one 325 ms task). */
  L.idle = function (fn) { var run = function () { try { fn(); } catch (e) { if (window.console) { console.error(e); } } }; if (window.requestIdleCallback) { window.requestIdleCallback(run, { timeout: 1500 }); } else { window.setTimeout(run, 1); } };   /* Safari / in-app browsers: no requestIdleCallback */
  if (L.lite) { document.documentElement.classList.add('is-lite'); }
  /* Pinch-zoomed in: the page's own swipes (gallery, reviews, carousels) let go, so one finger pans the zoomed view and
     two fingers can always zoom back out (L.zoomed). In-app browsers also re-render every glass/blur layer at the zoom
     scale and run out of graphics memory (only the blue page background is left): while zoomed, blur and animations
     rest there (CSS html.is-lite.is-zoomed). */
  L.zoomed = function () { return !!(window.visualViewport && window.visualViewport.scale > 1.05); };
  if (window.visualViewport) {
    (function (vv) {
      var on = false;
      function check() { var z = vv.scale > 1.05; if (z !== on) { on = z; document.documentElement.classList.toggle('is-zoomed', z); } }
      vv.addEventListener('resize', check); check();
      /* in-app browsers: the light mode starts with the pinch itself (2nd finger down), before the browser re-renders
         the page at the new scale; it ends after the fingers lift if the page is back at its normal size */
      if (L.lite) {
        document.addEventListener('touchstart', function (e) { if (e.touches.length > 1 && !on) { on = true; document.documentElement.classList.add('is-zoomed'); } }, { passive: true });
        document.addEventListener('touchend', function (e) { if (!e.touches.length) { window.setTimeout(function () { on = vv.scale > 1.05; document.documentElement.classList.toggle('is-zoomed', on); }, 400); } }, { passive: true });
      }
    })(window.visualViewport);
  }

  /* ---------- tracking: Clarity events, only once Clarity is loaded (after consent) ---------- */
  L.track = function (name, detail) {
    if (!name || typeof window.clarity !== 'function') { return; }
    try { if (detail) { window.clarity('set', name, detail); } window.clarity('event', name); } catch (e) { /* never break the page */ }
  };
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-track]');
    if (el) { L.track(el.getAttribute('data-track'), el.getAttribute('data-track-detail')); }
  });

  /* ---------- in-view helper: fn(entry) once the element is on screen ---------- */
  L.onView = function (el, fn, opts) {
    if (!el) { return; }
    if (!('IntersectionObserver' in window)) { fn({ isIntersecting: true, target: el }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fn(en); } }); }, opts || { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
  };

  /* ---------- dispatch and delivery: one function for the hero, the product section and the sticky bar ----------
     From Theme settings > Shipping (Stockholm time). Before the cut-off on a dispatch day the order ships today, else on
     the next dispatch day, plus the handling days; in batch mode on the batch date while that is still ahead (no
     handling days: the batch date is the ship day). Delivery counts banking
     days (no weekends, no Swedish bank holidays, no extra holidays from the settings) after the ship day: the home
     country (Sweden) gets one date, every other country a range. */
  /* Swedish bank holidays for a year, as 'YYYY-MM-DD' (Easter by the Gregorian computus; Midsummer Eve is the Friday
     between June 19 and 25). All Saints' Day is always a Saturday, so it needs no entry. */
  L.seHolidays = function (y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var easter = Date.UTC(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    var iso = function (t) { return new Date(t).toISOString().slice(0, 10); };
    var midsummer = Date.UTC(y, 5, 19); while (new Date(midsummer).getUTCDay() !== 5) { midsummer += 864e5; }
    return ['01-01', '01-06', '05-01', '06-06', '12-24', '12-25', '12-26', '12-31'].map(function (md) { return y + '-' + md; })
      .concat([iso(easter - 2 * 864e5), iso(easter + 864e5), iso(easter + 39 * 864e5), iso(midsummer)]);
  };
  /* The visitor's country: the waitlist's detection (snippets/waitlist-head.liquid: test, picker choice, or a confident
     detection), else the shop's localization country. */
  L.visitorCountry = function () { var W = window.LagomWL; return (W && W.country) || C.country || ''; };
  /* "Arrives Fri, Oct 30" / "Arrives Oct 30 – Nov 3" in this language. */
  L.arrivalText = function (info, short) {
    var t = C.t || {};
    if (info.single) { return L.fill(t.arrivesOn || 'Arrives [date]', { date: short ? info.arriveShort : info.arriveDate }); }
    return L.fill(t.arrivesBetween || 'Arrives [range]', { range: short ? info.arriveShort : info.arriveRange });
  };
  L.dispatchInfo = function (now) {
    var c = C.cutoff || { hour: 15, minute: 0, tz: 'Europe/Stockholm', days: ['1', '2', '3', '4', '5'], holidays: [] };
    var d = C.delivery || { home: 'SE', handling: 1, homeDays: 2, min: 2, max: 4 }, locale = C.locale || 'en', s = C.ship || {};
    var days = (c.days || []).map(function (x) { x = parseInt(x, 10); return x === 7 ? 0 : x; }).filter(function (x) { return !isNaN(x); });
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: c.tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now || new Date());
    var get = function (t) { for (var i = 0; i < parts.length; i++) { if (parts[i].type === t) { return parseInt(parts[i].value, 10); } } return 0; };
    var day = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
    var holidays = (c.holidays || []).map(function (x) { return String(x).trim(); }).filter(Boolean)
      .concat(L.seHolidays(get('year')), L.seHolidays(get('year') + 1));
    var iso = function (x) { return x.toISOString().slice(0, 10); };
    var isDispatch = function (x) { return days.indexOf(x.getUTCDay()) !== -1 && holidays.indexOf(iso(x)) === -1; };
    var isBusiness = function (x) { var w = x.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(iso(x)) === -1; };
    var next = function (x, test) { var r = new Date(x.getTime() + 864e5); while (!test(r)) { r = new Date(r.getTime() + 864e5); } return r; };
    var after = function (x, n) { for (var k = 0; k < n; k++) { x = next(x, isBusiness); } return x; };
    var minsLeft = (c.hour * 60 + c.minute) - (get('hour') * 60 + get('minute'));
    var orderToday = isDispatch(day) && minsLeft > 0;   /* before the cut-off: handling starts today */
    var ship = orderToday ? day : next(day, isDispatch);
    /* Batch mode: nothing ships before the batch date (its day in Stockholm) while that is still ahead. */
    var batchAt = s.mode === 'batch' && s.at ? Date.parse(s.at) : NaN, batchPending = batchAt > (now || new Date()).getTime();
    if (batchPending) {
      var bp = new Intl.DateTimeFormat('en-CA', { timeZone: c.tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(batchAt));
      var bday = new Date(bp + 'T00:00:00Z');
      ship = isDispatch(bday) ? bday : next(bday, isDispatch);
      orderToday = false;
    }
    /* Handling days (every country), except for a batch: its date is the day it ships. */
    if (!batchPending) { for (var hd = 0; hd < (d.handling || 0); hd++) { ship = next(ship, isDispatch); } }
    var country = L.visitorCountry(), home = !country || country === (d.home || 'SE');
    var from = after(ship, home ? d.homeDays : d.min), to = after(ship, home ? d.homeDays : d.max);
    var fmt = function (x, o) { return new Intl.DateTimeFormat(locale, Object.assign({ timeZone: 'UTC' }, o)).format(x); };
    var range = function (a, b, month) {
      var o = { day: 'numeric', month: month, timeZone: 'UTC' };
      try { return new Intl.DateTimeFormat(locale, o).formatRange(a, b); } catch (e) { return fmt(a, o) + ' – ' + fmt(b, o); }
    };
    var single = iso(from) === iso(to);
    return {
      orderToday: orderToday, minsLeft: orderToday ? minsLeft : 0, batchPending: batchPending,
      shipsToday: iso(ship) === iso(day), shipTomorrow: (ship - day) === 864e5, shipName: fmt(ship, { weekday: 'long' }),
      single: single,
      arriveDate: fmt(from, { weekday: 'long', day: 'numeric', month: 'long' }),
      arriveRange: range(from, to, 'long'),
      arriveShort: single ? fmt(from, { weekday: 'short', day: 'numeric', month: 'short' }) : range(from, to, 'short'),
      arriveGet: fmt(from, { weekday: 'long', day: 'numeric', month: 'short' }),
      deliverLabel: fmt(to, { weekday: 'short', day: 'numeric', month: 'short' }),
      deliverLong: fmt(to, { weekday: 'long', day: 'numeric', month: 'short' })
    };
  };
  /* Short arrival lines ([data-arrives-short]: announcement bar, sticky buy bar, cart notes). [data-arrives-sep] puts
     " · " in front, [data-arrives-get] says "Get it Monday, Nov 2". Again when the country is detected, after cart
     updates, and every minute. */
  /* While a batch is ahead: the batch window from Theme settings ("October 29" / "Oct 29", typed in English) in the
     visitor's language, in the delivery line, announcement bar, sticky bar and carts. */
  L.localizeBatch = function (root) {
    var s = C.ship || {}, at = Date.parse(s.at || ''), locale = C.locale || 'en';
    if (!(at > Date.now()) || locale.slice(0, 2) === 'en') { return; }
    var tz = (C.cutoff || {}).tz || 'Europe/Stockholm';
    var swap = [[s.window, { day: 'numeric', month: 'long' }], [s.short, { day: 'numeric', month: 'short' }]]
      .filter(function (x) { return x[0]; })
      .map(function (x) { return [x[0], new Intl.DateTimeFormat(locale, Object.assign({ timeZone: tz }, x[1])).format(new Date(at))]; });
    qa('[data-eta-sub], .announcement__text, .buybar__delivery, .cart-panel__note, .cart__note', root).forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        swap.forEach(function (x) { if (v.indexOf(x[0]) > -1) { v = v.split(x[0]).join(x[1]); } });
        if (v !== n.nodeValue) { n.nodeValue = v; }
      }
    });
  };
  L.fillArrivals = function (root) {
    try { L.localizeBatch(root); } catch (e) { /* keep the Liquid text */ }
    var els = qa('[data-arrives-short]', root);
    if (!els.length) { return; }
    try {
      var info = L.dispatchInfo(new Date()), t = C.t || {};
      var text = L.arrivalText(info, true), get = L.fill(t.getIt || 'Get it [date]', { date: info.single ? info.arriveGet : info.arriveShort });
      els.forEach(function (el) {
        el.textContent = (el.hasAttribute('data-arrives-sep') ? ' · ' : '') + (el.hasAttribute('data-arrives-get') ? get : text);
        el.hidden = false;
      });
    } catch (e) { /* keep the Liquid text */ }
  };
  /* Batch mode countdown: { days, text: "5d 20h 58m 19s" } or null when the date has passed / is not set. */
  L.batchCountdown = function () {
    var s = C.ship || {};
    if (s.mode !== 'batch' || !s.at) { return null; }
    var ms = Date.parse(s.at) - Date.now();
    if (!(ms > 0)) { return null; }
    var t = Math.floor(ms / 1000);
    return { days: Math.ceil(ms / 864e5), text: Math.floor(t / 86400) + 'd ' + Math.floor(t % 86400 / 3600) + 'h ' + Math.floor(t % 3600 / 60) + 'm ' + (t % 60) + 's' };
  };
  L.fill = function (tpl, vars) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return vars[k] != null ? vars[k] : m; }); };
  (function () {
    var run = function () { L.fillArrivals(); };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    [1500, 4000].forEach(function (ms) { setTimeout(run, ms); });
    setInterval(run, 60000);
    document.addEventListener('lagom:cart', function () { setTimeout(run, 50); });
    document.addEventListener('shopify:section:load', run);
  })();

  /* ---------- header: floating glass pill after the first scroll; light mode over [data-light] sections ---------- */
  (function () {
    var header = q('[data-header]');
    if (!header) { return; }
    var lights = qa('[data-light]'), raf = 0, floating = false, ann = q('[data-announcement]');
    /* Positions are measured once (load, resize, fonts, section changes), never while scrolling: the scroll handler only
       reads pageYOffset and writes. (Reading layout after a write every scroll frame was a forced reflow per frame.) */
    var annH = 0, headMid = 40, ranges = [], lastTop = '';
    function measure() {
      var y = window.pageYOffset;
      annH = ann ? ann.offsetHeight : 0;
      var inner = q('.header__inner', header), r = inner ? inner.getBoundingClientRect() : header.getBoundingClientRect();
      headMid = r.top + r.height / 2;   /* the pill's centre on screen (fixed) */
      ranges = lights.map(function (el) { var b = el.getBoundingClientRect(); return [b.top + y, b.bottom + y]; });
      document.documentElement.style.setProperty('--ann-h', annH + 'px');
    }
    function update() {
      raf = 0;
      var y = L.scrollY, on = y > 24;
      /* The fixed header starts under the announcement bar and takes its place once the bar has scrolled away. */
      var top = Math.max(0, annH - y) + 'px'; if (top !== lastTop) { header.style.top = top; lastTop = top; }   /* one write per change, not per frame */
      if (on !== floating) {
        floating = on;
        header.classList.toggle('is-floating', on);
        if (on) { window.setTimeout(function () { header.classList.add('is-dropped'); }, 600); } else { header.classList.remove('is-dropped'); }
        window.setTimeout(function () { L.idle(function () { measure(); document.dispatchEvent(new CustomEvent('lagom:layout')); }); }, 650);   /* the pill moves when it starts floating: measure again after the drop, and tell the clouds */
      }
      var mid = y + headMid, light = false;
      for (var i = 0; i < ranges.length; i++) { if (ranges[i][0] <= mid && ranges[i][1] >= mid) { light = true; break; } }
      header.classList.toggle('is-on-light', light);
    }
    /* --header-height: the bottom edge of the floating pill (its top margin + height), for the anchor offsets
       (section[id] and .anchor-target land 32px under it). Measured with the floating style applied for a moment
       when the page is still at the top, as in the prototype. */
    /* --header-height (the floating pill's bottom edge, for anchor offsets) is a CSS constant now: 64px, 62px on phones
       and tablets. Measuring it here meant toggling the floating class and reading layout during script execution. */
    function tick() { if (!raf) { raf = window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { measure(); tick(); });
    window.addEventListener('load', function () { measure(); tick(); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { measure(); tick(); }); }
    document.addEventListener('shopify:section:load', function () { lights = qa('[data-light]'); measure(); tick(); });
    document.addEventListener('lagom:layout', function () { measure(); tick(); });
    /* First measurement in a frame after the first paint (layout is clean then: no forced reflow during load). */
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { measure(); update(); }); });
  })();

  /* ---------- phone menu: unrolls under the pill; closes on a link, Esc, a tap outside, or a scroll ---------- */
  (function () {
    var btn = q('[data-menu-toggle]'), nav = q('[data-menu]'), hd = q('[data-header]');
    if (!btn || !nav) { return; }
    var closeTimer = 0, openY = 0;
    function set(open) {
      window.clearTimeout(closeTimer);
      var phone = window.matchMedia('(max-width: 1023px)').matches;
      if (open) { document.dispatchEvent(new CustomEvent('lagom:panel', { detail: 'menu' })); nav.classList.remove('is-closing'); nav.classList.add('is-open'); if (hd) { hd.classList.add('is-menu-open'); } openY = window.pageYOffset; if (phone) { L.lock.lock('menu'); } }
      else if (nav.classList.contains('is-open') && !L.motionOff()) {
        nav.classList.add('is-closing'); L.lock.unlock('menu');
        closeTimer = window.setTimeout(function () { nav.classList.remove('is-open', 'is-closing'); if (hd) { hd.classList.remove('is-menu-open'); } }, 220);
      } else { nav.classList.remove('is-open', 'is-closing'); if (hd) { hd.classList.remove('is-menu-open'); } L.lock.unlock('menu'); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    /* A menu link to a section on this page: close the menu first (the scroll position comes back), then one smooth
       scroll to the target (scroll-margin-top = the header offset). Other links: close and let the browser go. */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) { return; }
      var href = a.getAttribute('href') || '', hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#') + 1) : '';
      var path = href.split('#')[0], samePage = !path || path === location.pathname || path === location.pathname + location.search;
      var target = hash && samePage ? document.getElementById(hash) : null;
      set(false);
      if (!target) { return; }
      e.preventDefault();
      window.requestAnimationFrame(function () { target.scrollIntoView({ behavior: L.motionOff() ? 'auto' : 'smooth', block: 'start' }); if (history.replaceState) { history.replaceState(null, '', '#' + hash); } });
    });
    window.addEventListener('scroll', function () { if (btn.getAttribute('aria-expanded') === 'true' && !L.lock.has('menu') && Math.abs(window.pageYOffset - openY) > 12) { set(false); } }, { passive: true });
    document.addEventListener('click', function (e) { if (btn.getAttribute('aria-expanded') === 'true' && !nav.contains(e.target) && !btn.contains(e.target)) { set(false); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); } });
    document.addEventListener('lagom:panel', function (e) { if (e.detail !== 'menu' && btn.getAttribute('aria-expanded') === 'true') { set(false); } });
  })();

  /* ---------- cart: count in the header (with a bump), add via the AJAX API, toast ----------
     L.cart.add(variantId, quantity) -> Promise. Every query is null-guarded; nothing here can throw on a page
     without a header or a toast. */
  (function () {
    var counts = qa('[data-cart-count]'), toast = q('[data-toast]'), toastTimer = 0;
    function setCount(n) {
      counts.forEach(function (el) {
        el.textContent = n;
        var label = el.closest('[data-cart-link]');
        if (label) { label.setAttribute('aria-label', L.fill(C.t && C.t.cartCount ? C.t.cartCount : 'Cart, [n] items', { n: n })); label.classList.toggle('has-items', n > 0); }
        document.documentElement.classList.toggle('cart-empty', !(n > 0));
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    }
    function showToast(text) {
      if (!toast) { return; }
      var t = q('[data-toast-text]', toast); if (t) { t.textContent = text; }
      toast.hidden = false; toast.classList.add('is-in');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-in'); window.setTimeout(function () { toast.hidden = true; }, 300); }, 4000);
    }
    L.cart = {
      setCount: setCount,
      toast: showToast,
      add: function (id, quantity, opts) {
        var routes = C.routes || {}, silent = !!(opts && opts.silent);   // silent: no toast and the cart window stays closed (checkout)
        return fetch((routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }], sections: 'cart-drawer' })
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) { var err = new Error(data.description || data.message || 'error'); err.data = data; throw err; }
            return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.json(); }).then(function (cart) {
              setCount(cart.item_count);
              cart.sections = data.sections;   // the rendered cart window, when the page has one
              cart.silent = silent;
              if (!silent && !q('[data-cart-panel]')) { showToast(C.t && C.t.added ? C.t.added : 'Added to cart'); }
              document.dispatchEvent(new CustomEvent('lagom:cart', { detail: cart }));
              return cart;
            });
          });
        });
      }
    };
  })();

  /* ---------- reveal: [data-reveal] elements fade and lift in once on screen (motion off: visible at once) ---------- */
  (function () {
    var els = qa('[data-reveal]');
    if (!els.length) { return; }
    if (L.motionOff() || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  })();

  L.idle(function () {
  /* ---------- localization: the country pill (header) ----------
     Picking a country submits the localization form with that country and the language the item carries
     (data-lsel-to-lang: the country's native language when published, else English). [data-lsel-switch] changes
     only the language. First visit: Shopify's /browsing_context_suggestions.json names the visitor's country (IP);
     if it is one of the markets and not the current one, switch the country once and send no language (the language
     comes from the browser: snippets/lang-redirect.liquid). lagom_loc keeps only the country; a choice in the picker
     is saved in lagom_lang, which stops the first-visit language redirect for good. Nothing runs in the theme editor
     or with ?capture=1. */
  (function () {
    var COOKIE = 'lagom_loc';
    /* The decision is kept in a cookie, localStorage and sessionStorage: in-app browsers (TikTok, Instagram) drop some of these. */
    function store(k) { try { return window[k]; } catch (e) { return null; } }
    function cookie(name) { var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)'); var v = m ? decodeURIComponent(m[1]) : ''; if (!v) { try { v = (store('localStorage') && localStorage.getItem(name)) || (store('sessionStorage') && sessionStorage.getItem(name)) || ''; } catch (e) {} } return v; }
    function remember(v, name) { name = name || COOKIE; document.cookie = name + '=' + encodeURIComponent(v) + '; path=/; max-age=31536000; SameSite=Lax'; try { localStorage.setItem(name, v); } catch (e) {} try { sessionStorage.setItem(name, v); } catch (e) {} }
    function closeAll(except) { qa('[data-lsel]').forEach(function (d) { if (d === except) { return; } var b = q('[data-lsel-btn]', d), m = q('[data-lsel-menu]', d); if (b && b.getAttribute('aria-expanded') !== 'false') { b.setAttribute('aria-expanded', 'false'); } if (m && !m.hidden) { m.hidden = true; } }); }
    /* manual: a click in the picker (saves the language too). Otherwise the geo switch: country only, no locale_code. */
    function go(dd, country, lang, manual) {
      var form = dd.closest('form');
      var ci = q('[data-lsel-input="country_code"]', dd), li = q('[data-lsel-input="locale_code"]', dd);
      if (ci && country) { ci.value = country; }
      if (li) { if (manual) { if (lang) { li.value = lang; } li.disabled = false; } else { li.disabled = true; } }
      remember(country || (ci && ci.value) || '');
      if (manual) { remember(lang || (li && li.value) || '', 'lagom_lang'); }
      closeAll(); if (form) { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } }
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lsel-btn]');
      var item = e.target.closest && e.target.closest('[data-lsel-value]');
      var sw = e.target.closest && e.target.closest('[data-lsel-switch]');
      if (btn) {
        var d = btn.closest('[data-lsel]'), m = q('[data-lsel-menu]', d), open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(d); btn.setAttribute('aria-expanded', open ? 'false' : 'true'); if (m) { m.hidden = open; }
        e.stopPropagation(); return;
      }
      if (item) { go(item.closest('[data-lsel]'), item.getAttribute('data-lsel-value'), item.getAttribute('data-lsel-to-lang'), true); return; }
      if (sw) { go(sw.closest('[data-lsel]'), '', sw.getAttribute('data-lsel-switch'), true); return; }
      if (!e.target.closest || !e.target.closest('[data-lsel]')) { closeAll(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); } });

    /* Geo suggestion, once. */
    var dd = q('[data-lsel]');
    if (!dd || cookie(COOKIE) || CAPTURE || (window.Shopify && window.Shopify.designMode) || !window.fetch) { return; }
    var root = (C.routes && C.routes.root) || '/';
    if (root.slice(-1) !== '/') { root += '/'; }
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var det = data && data.detected_values, c = det && det.country && det.country.handle;
        if (!c) { remember('none'); return; }
        c = String(c).toUpperCase();
        var item = q('[data-lsel-value="' + c + '"]', dd);
        if (!item || c === dd.getAttribute('data-lsel-current')) { remember(c); return; }
        go(dd, c);
      })
      .catch(function () { /* no suggestion: stay */ });
  })();

  });

  /* ---------- ?perf=1&key=lagom-test: live frame-time overlay for testing in in-app browsers (also in the editor) ---------- */
  if (/[?&]perf=1(?:&|$)/.test(location.search) && (/[?&]key=lagom-test(?:&|$)/.test(location.search) || !!(window.Shopify && window.Shopify.designMode))) {
    (function () {
      var ua = navigator.userAgent, name = L.inApp || (/CriOS|Chrome/.test(ua) ? 'Chrome' : /FxiOS|Firefox/.test(ua) ? 'Firefox' : /Safari/.test(ua) ? 'Safari' : 'other');
      var hud = document.createElement('div'); hud.className = 'perf-hud'; hud.setAttribute('aria-hidden', 'true'); document.body.appendChild(hud);
      var deltas = [], last = performance.now(), log = [], tab = null, n = 0;
      function tick(now) {
        var d = now - last; last = now; deltas.push([now, d]);
        while (deltas.length && deltas[0][0] < now - 2000) { deltas.shift(); }
        if (tab) { tab.frames++; if (d > tab.worst) { tab.worst = d; } tab.dropped += Math.max(0, Math.round(d / 16.7) - 1); if (now > tab.until) { log.unshift(tab.what + ' #' + tab.n + ': ' + tab.frames + ' frames, worst ' + Math.round(tab.worst) + ' ms, ' + tab.dropped + ' dropped'); log = log.slice(0, 4); tab = null; } }
        if (!(n++ % 6)) {
          var worst = 0, sum = 0; deltas.forEach(function (x) { sum += x[1]; if (x[1] > worst) { worst = x[1]; } });
          var fps = deltas.length ? Math.round(1000 / (sum / deltas.length)) : 0;
          hud.textContent = name + '\n' + fps + ' fps  worst 2s: ' + Math.round(worst) + ' ms' + (log.length ? '\n' + log.join('\n') : '') + '\nUA: ' + ua;
        }
        window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
      document.addEventListener('click', function (e) {
        var sm = e.target.closest && e.target.closest('summary'); if (!sm) { return; }
        var d = sm.parentNode, items = qa('details.faq__item, details[data-animate]');
        tab = { what: d.classList.contains('is-open') ? 'close' : 'open', n: items.indexOf(d) + 1, frames: 0, worst: 0, dropped: 0, until: performance.now() + 600 };
      }, true);
    })();
  }

  /* ---------- details (FAQ, product details): the unfold ----------
     With JS every <details> stays [open]; a question's panel is folded or unfolded by one class on the item
     (.is-open) and the aria-expanded state on the summary. The height (grid row 0fr -> 1fr), the fade and the chevron
     are CSS transitions (section-faq.css): no measuring, no per-frame script. Items are independent: opening one never
     closes another. The modules that cache page geometry (header, clouds, timeline) are told once, in idle time, after
     the fold has finished. Links to a question (#faq-bluetooth) open it. No JS: native <details>. */
  (function () {
    var DUR = 260;
    function bind(d) {
      if (d.dataset.bound) { return; }
      d.dataset.bound = '1';
      var sum = d.querySelector('summary');
      if (!sum || !sum.nextElementSibling) { return; }
      var wasOpen = d.open;
      d.open = true;                                   /* laid out from now on; CSS folds it */
      function set(open) {
        d.classList.toggle('is-open', open); sum.setAttribute('aria-expanded', open ? 'true' : 'false');
        window.clearTimeout(L.layoutTimer);
        L.layoutTimer = window.setTimeout(function () { L.idle(function () { document.dispatchEvent(new CustomEvent('lagom:layout')); }); }, DUR + 40);
        d.dispatchEvent(new CustomEvent('lagom:tab', { detail: { open: open } }));
      }
      d.classList.toggle('is-open', wasOpen); sum.setAttribute('aria-expanded', wasOpen ? 'true' : 'false');
      d.lagomIsOpen = function () { return d.classList.contains('is-open'); };
      d.lagomOpen = function () { if (!d.lagomIsOpen()) { set(true); } };
      d.lagomClose = function () { if (d.lagomIsOpen()) { set(false); } };
      sum.addEventListener('pointerdown', function () { sum.classList.add('is-pressed'); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { sum.addEventListener(t, function () { sum.classList.remove('is-pressed'); }); });
      sum.addEventListener('click', function (e) { e.preventDefault(); set(!d.lagomIsOpen()); });
    }
    qa('details.faq__item, details[data-animate]').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) { qa('details.faq__item, details[data-animate]', e.target).forEach(bind); });
    document.addEventListener('shopify:block:select', function (e) { var d = e.target.closest && e.target.closest('details'); if (d && d.lagomOpen) { d.lagomOpen(); } });
    function openHash() { var id = location.hash.slice(1); if (!id) { return; } var d = document.getElementById(id); if (d && d.lagomOpen) { d.lagomOpen(); } }
    window.addEventListener('hashchange', openHash); openHash();
  })();

  L.idle(function () {
  /* ---------- Edge-swipe guard: a horizontal swipe that starts at the screen edge over a carousel (gallery, review cards,
     videos) must scroll the carousel, not trigger the browser's back/forward gesture (iOS Safari, TikTok/Instagram browsers). */
  document.addEventListener('touchstart', function (e) {
    var t = e.touches && e.touches[0]; if (!t) { return; }
    var x = t.clientX, edge = 32;
    if (x > edge && x < window.innerWidth - edge) { return; }
    var y = t.clientY, hit = e.target.closest && e.target.closest('.buy__slides, .scards, .social__videos, .buy__gallery, [data-edge-guard]');
    if (!hit) { hit = qa('.buy__slides, .scards, .social__videos, .buy__gallery, [data-edge-guard]').some(function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && y >= r.top && y <= r.bottom; }); }
    if (hit) { e.preventDefault(); }
  }, { passive: false });

  });

  L.idle(function () {
  /* ---------- Footer: the links live in a popup above the copyright line ---------- */
  qa('[data-footer-links]').forEach(function (btn) {
    var pop = document.getElementById(btn.getAttribute('aria-controls')); if (!pop) { return; }
    function set(open) { pop.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }   /* focus stays on the button: no ring on the first link after a tap */
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); set(pop.hidden); });
    document.addEventListener('click', function (e) { if (!pop.hidden && !pop.contains(e.target) && e.target !== btn) { set(false); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { set(false); btn.focus(); } });
  });


  });

  L.idle(function () {
  /* ---------- Carousels on touch screens: the page drives the horizontal swipe ----------
     Native horizontal scrolling lets in-app browsers (TikTok, Instagram) read the same swipe as "go back / close".
     Here touch-action: pan-y leaves vertical scrolling to the browser; a horizontal move is taken over (preventDefault),
     scrollLeft follows the finger, and on release the track snaps to the nearest card (a flick moves one card). */
  (function () {
    var SEL = '.social__videos, [data-swipe-track]';   /* the gallery (.buy__slides) and the review deck (.scards) have their own swipes that cancel the touch */
    var el = null, x0 = 0, y0 = 0, s0 = 0, lastX = 0, lastT = 0, vx = 0, lock = 0;   // lock: 0 undecided, 1 horizontal, -1 vertical
    function kids(t) { return Array.prototype.filter.call(t.children, function (c) { return c.offsetWidth > 0; }); }
    function snap(t, dir) {
      var pad = parseFloat(getComputedStyle(t).scrollPaddingInlineStart || getComputedStyle(t).scrollPaddingLeft) || 0;
      var cs = kids(t), best = null, bd = Infinity, cur = t.scrollLeft;
      cs.forEach(function (c) { var d = Math.abs(c.offsetLeft - pad - cur); if (d < bd) { bd = d; best = c; } });
      if (!best) { return; }
      var i = cs.indexOf(best);
      if (dir > 0 && i < cs.length - 1 && best.offsetLeft - pad <= cur + 2) { best = cs[i + 1]; }
      if (dir < 0 && i > 0 && best.offsetLeft - pad >= cur - 2) { best = cs[i - 1]; }
      t.scrollTo({ left: Math.max(0, best.offsetLeft - pad), behavior: 'smooth' });
    }
    document.addEventListener('touchstart', function (e) {
      var t = e.target.closest && e.target.closest(SEL); el = null;
      if (!t || e.touches.length !== 1) { return; }
      if (L.zoomed()) { return; }
      el = t; x0 = lastX = e.touches[0].clientX; y0 = e.touches[0].clientY; s0 = t.scrollLeft; lastT = e.timeStamp; vx = 0; lock = 0;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!el) { return; }
      if (e.touches.length > 1) { end(); return; }   /* a second finger = pinch zoom: the browser's */
      var x = e.touches[0].clientX, y = e.touches[0].clientY, dx = x - x0, dy = y - y0;
      if (!lock) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) { return; } lock = Math.abs(dx) > Math.abs(dy) ? 1 : -1; if (lock === 1) { el.classList.add('is-swiping'); } }
      if (lock !== 1) { return; }
      e.preventDefault();
      el.scrollLeft = s0 - dx;
      var dt = e.timeStamp - lastT; if (dt > 0) { vx = (x - lastX) / dt; }
      lastX = x; lastT = e.timeStamp;
    }, { passive: false });
    function end() {
      if (!el) { return; }
      var t = el; el = null;
      if (lock === 1) { var dir = vx < -0.25 ? 1 : vx > 0.25 ? -1 : 0; snap(t, dir); window.setTimeout(function () { t.classList.remove('is-swiping'); }, 650); }   /* snapping stays off until the smooth scroll has landed, or the browser snaps back first */
      lock = 0;
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  })();


  });

  L.idle(function () {
  /* ---------- Off-screen sections: CSS animations paused (resumed where they were when the section comes back) ----------
     Invisible on screen; saves the compositor work of the marquee, ripples, water, flowers, butterflies and bubbles. */
  (function () {
    if (!('IntersectionObserver' in window)) { return; }
    /* Only the page's own sections (main + footer): never the header, the cart drawer, the cookie banner or any fixed
       overlay. Those live in sections whose box is not where their content shows, and a paused open animation
       (clip-path at frame 0) made the phone menu and the cart invisible. */
    var tops = qa('main > *, [id^="shopify-section-footer"], .footer-group > *').filter(function (el, i, arr) { return !arr.some(function (o) { return o !== el && o.contains(el); }); })
      .filter(function (el) { return !el.querySelector('.header, .cart-panel, .cc, dialog, [data-cart-panel], [data-buybar]') && !el.matches('.header, .cart-panel'); });   /* nor the sticky bar: fixed on screen, its spinner froze */
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { en.target.classList.toggle('is-offscreen', !en.isIntersecting); }); }, { rootMargin: '120px 0px' });
    tops.forEach(function (el) { io.observe(el); });
  })();


  });

  L.idle(function () {
  /* ---------- Tabs: nothing heavy on the first open ----------
     When a details list (product tabs, FAQ) comes within 600px of the screen, every image inside its closed panels is
     loaded and decoded during idle time (no loading=lazy inside panels), and videos get their poster decoded and
     preload=metadata, so the first click only has to show what is already there. */
  (function () {
    var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 1500 }); } : function (f) { window.setTimeout(f, 1); };
    function prime(list) {
      if (list.dataset.primed) { return; } list.dataset.primed = '1';
      qa('details img', list).forEach(function (img) {
        if (img.loading === 'lazy') { img.loading = 'eager'; }
        idle(function () { if (img.decode) { img.decode().catch(function () {}); } });
      });
      qa('details video', list).forEach(function (v) {
        if (v.hasAttribute('data-kbd-video')) { return; }   /* the keyboard video loads itself once it is near (section-buy.js) */
        if (v.preload === 'none') { v.preload = 'metadata'; }
        var poster = v.getAttribute('poster');
        if (poster) { idle(function () { var im = new Image(); im.src = poster; if (im.decode) { im.decode().catch(function () {}); } }); }
      });
    }
    var lists = qa('.faq__list, .buy__list, .buy__details');
    if (!('IntersectionObserver' in window)) { lists.forEach(prime); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); prime(en.target); } }); }, { rootMargin: '600px 0px' });
    lists.forEach(function (l) { io.observe(l); });
  })();
  });


})();
